var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _line, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _path4, _line2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path5, _path6, _line3, _rect18, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 304,
    viewBox: "0 0 305 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 152,
    r: 152,
    fill: "#F3F3F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3300_175658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 305,
    height: 304
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 152,
    r: 152,
    fill: "#DEDEE9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3300_175658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.4317 95.4442C50.3624 79.886 36.6859 68.2061 20.2561 68.2061C7.21149 68.2061 -4.11786 75.6018 -9.75997 86.4249C-23.3462 87.868 -33.9082 99.3675 -33.9082 113.302C-33.9082 128.229 -21.7664 140.36 -6.82607 140.36H51.8519C64.3096 140.36 74.4203 130.258 74.4203 117.812C74.4203 105.906 65.1673 96.2559 53.4317 95.4442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.205 48.0794C100.182 42.8933 95.6232 39 90.1466 39C85.7984 39 82.0219 41.4653 80.1412 45.073C75.6125 45.554 72.0918 49.3872 72.0918 54.0321C72.0918 59.0077 76.1391 63.0513 81.1192 63.0513H100.678C104.831 63.0513 108.201 59.6841 108.201 55.5353C108.201 51.5668 105.117 48.3499 101.205 48.0794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.455 88.6952C162.896 80.9161 155.949 75.0762 147.604 75.0762C140.978 75.0762 135.223 78.7741 132.358 84.1856C125.457 84.9071 120.092 90.6569 120.092 97.6243C120.092 105.088 126.259 111.153 133.848 111.153H163.652C169.98 111.153 175.116 106.102 175.116 99.8791C175.116 93.9264 170.416 89.1011 164.455 88.6952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.081 166.238C231.15 150.68 244.826 139 261.256 139C274.301 139 285.63 146.396 291.272 157.219C304.858 158.662 315.42 170.161 315.42 184.096C315.42 199.023 303.279 211.154 288.338 211.154H229.66C217.203 211.154 207.092 201.052 207.092 188.606C207.092 176.7 216.345 167.05 228.081 166.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.419 75.1794C232.221 66.289 240.253 59.6147 249.903 59.6147C257.564 59.6147 264.217 63.8409 267.531 70.0255C275.51 70.8501 281.713 77.4213 281.713 85.384C281.713 93.9136 274.582 100.846 265.808 100.846H231.346C224.03 100.846 218.092 95.0732 218.092 87.9609C218.092 81.1578 223.526 75.6432 230.419 75.1794Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103.956,
    y: 197.038,
    width: 189.251,
    height: 30.5243,
    rx: 4,
    fill: "#CDCEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 108.119,
    y: 193.875,
    width: 194.356,
    height: 29.5243,
    rx: 3.5,
    fill: "#F3F3F7",
    stroke: "#B9BBD2",
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 119.708,
    y: 205.667,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133.36,
    y: 205.667,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 177.466,
    y: 205.667,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.522 208.817C220.522 207.077 221.932 205.667 223.672 205.667H254.127C255.867 205.667 257.277 207.077 257.277 208.817C257.277 210.557 255.867 211.968 254.127 211.968H223.672C221.932 211.968 220.522 210.557 220.522 208.817Z",
    fill: "#B9BBD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.578 208.817C263.578 207.077 264.989 205.667 266.729 205.667H281.431V211.968H266.729C264.989 211.968 263.578 210.557 263.578 208.817Z",
    fill: "#B9BBD2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 281.415,
    y1: 193.375,
    x2: 281.415,
    y2: 223.899,
    stroke: "#B9BBD2",
    strokeWidth: 0.834422
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 288.782,
    y: 205.667,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 138.851,
    width: 189.251,
    height: 30.5243,
    rx: 4,
    fill: "#CDCEDE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6631,
    y: 135.688,
    width: 194.356,
    height: 29.5243,
    rx: 3.5,
    fill: "#F3F3F7",
    stroke: "#B9BBD2",
    strokeDasharray: "2 2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2522,
    y: 147.479,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9041,
    y: 147.479,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 126.01,
    y: 147.479,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.066 150.63C169.066 148.89 170.476 147.479 172.216 147.479H202.671C204.41 147.479 205.821 148.89 205.821 150.63C205.821 152.37 204.41 153.78 202.671 153.78H172.216C170.476 153.78 169.066 152.37 169.066 150.63Z",
    fill: "#B9BBD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.122 150.63C212.122 148.89 213.533 147.479 215.273 147.479H229.975V153.78H215.273C213.533 153.78 212.122 152.37 212.122 150.63Z",
    fill: "#B9BBD2"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 229.958,
    y1: 135.188,
    x2: 229.958,
    y2: 165.712,
    stroke: "#B9BBD2",
    strokeWidth: 0.834422
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 237.326,
    y: 147.479,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 80.6633,
    width: 189.251,
    height: 30.5243,
    rx: 4,
    fill: "#CDCEDE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6.66309,
    y: 77.5,
    width: 194.356,
    height: 29.5243,
    rx: 3.5,
    fill: "#F3F3F7",
    stroke: "#B9BBD2",
    strokeDasharray: "2 2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2522,
    y: 89.292,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31.9041,
    y: 89.292,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 76.01,
    y: 89.292,
    width: 36.7551,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.066 92.4424C119.066 90.7025 120.476 89.292 122.216 89.292H152.671C154.41 89.292 155.821 90.7025 155.821 92.4424C155.821 94.1824 154.41 95.5929 152.671 95.5929H122.216C120.476 95.5929 119.066 94.1824 119.066 92.4424Z",
    fill: "#B9BBD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.122 92.4424C162.122 90.7025 163.533 89.292 165.273 89.292H179.975V95.5929H165.273C163.533 95.5929 162.122 94.1824 162.122 92.4424Z",
    fill: "#B9BBD2"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 179.958,
    y1: 77,
    x2: 179.958,
    y2: 107.524,
    stroke: "#B9BBD2",
    strokeWidth: 0.834422
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 187.326,
    y: 89.292,
    width: 6.30087,
    height: 6.30087,
    rx: 3.15043,
    fill: "#B9BBD2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6787 173.001H85.2581H76.5998L31.0728 218.813L46.7654 234.566L92.3997 188.869V180.162V179.744L92.6895 179.442L95.7955 176.21L96.4777 175.5L97.2231 176.143C110.172 187.317 126.977 194.039 145.251 194.039C186.008 194.039 219.053 160.873 219.053 119.951C219.053 79.0295 186.008 45.864 145.251 45.864C104.495 45.864 71.4494 79.0293 71.438 119.951L85.6787 173.001ZM85.6787 173.001L85.9808 172.708M85.6787 173.001L85.9808 172.708M85.9808 172.708L89.2006 169.59L89.9025 168.91M85.9808 172.708L89.9025 168.91M89.9025 168.91L89.2669 168.168M89.9025 168.91L89.2669 168.168M89.2669 168.168C78.1356 155.17 71.4381 138.31 71.438 119.952L89.2669 168.168ZM145.251 180.835C178.823 180.835 205.908 153.63 205.908 119.951C205.908 86.2726 178.823 59.0675 145.251 59.0675C111.679 59.0675 84.5948 86.2726 84.5948 119.951C84.5948 153.63 111.691 180.835 145.251 180.835Z",
    fill: "#CDCEDE",
    stroke: "#A6A8BB",
    strokeWidth: 2.07752
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1091 172.663H77.055L31.2861 219.382L46.4871 234.864L92.3568 188.248V180.045L85.1091 172.663Z",
    fill: "#A6A8BB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty_search.59b5152890b956926059e609b4330777.svg";
export { ForwardRef as ReactComponent };